import React, { useState } from 'react'
import PasswordAlertBox from './PasswordAlertBox'

const INITIAL_STATE = {
    verificationCode: "",
    password: "",
    isValid: false
}

function CompleteVerification(props){
    const [state,setState] = useState(INITIAL_STATE)

    const validateForm = () => {
        if(props.onSubmit){
            props.onSubmit(state)
        }
    }

    return <form>
    <div className="form-group">
        <label className="control-label">
            Verification Code
        </label>
        <input type="text" onChange={e => setState({ ...state, verificationCode: e.target.value}) } value={state.verificationCode} className="form-control input-lg" placeholder="Verification Code" name="verificationCode" required="" />
    </div>
    <div className="form-group">
        <label className="control-label">
            Password
        </label>
        <input type="password" onChange={e => setState({ ...state, password: e.target.value}) } value={state.password} className="form-control input-lg" placeholder="New Password" name="password" required="" />
    </div>
    <PasswordAlertBox password={state.password} onValidate={(isValid) => setState({...state, isValid})} />
    <div className="form-group">
        <button type="button" className="btn btn-success btn-lg btn-block" onClick={() => validateForm()} disabled={!state.isValid}>
            Complete Verification
        </button>
    </div>
</form>
}

CompleteVerification.defaultProps = {
    onSubmit: false
}

export default CompleteVerification